import { Button, Heading } from "@athena/forge";
import React from "react";
import { logEnrollFactorInitiated } from "../../lib/amplitude-utils";

export interface AvailableFactorProps {
  id: string;
  factorName: string;
  description: string;
  icon: string;
  setUpFactorHandler: () => void;
  buttonText: string;
}

const AvailableFactor = ({
  factorName,
  description,
  icon,
  setUpFactorHandler,
  buttonText,
}: AvailableFactorProps): React.JSX.Element => {
  return (
    <div className="uiam-edit-factor-row fe_u_margin--bottom-medium">
      <div className="enroll-factor-row clearfix">
        <div className="enroll-factor-icon-container fe_u_margin--right-medium">
          <div className={`factor-icon enroll-factor-icon ${icon}`}></div>
        </div>
      </div>
      <div>
        <Heading
          headingTag="h3"
          variant="section"
          text={factorName}
          className="fe_u_margin--bottom-small fe_u_font-size--default"
        />
        <p className="fe_u_margin--bottom-small fe_u_font-size--default fe_u_font-weight--default">
          {description}
        </p>
        <Button
          text={buttonText}
          variant="secondary"
          size="medium"
          onClick={async (e: React.MouseEvent) => {
            e.preventDefault();
            logEnrollFactorInitiated({ factorName });
            setUpFactorHandler();
          }}
        ></Button>
      </div>
    </div>
  );
};

export default AvailableFactor;
